import { CommonModule } from "@angular/common";
import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  Input,
  Query,
  TemplateRef,
  ViewChild,
  forwardRef,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import {
  NISTemplateModule,
  NISTemplateDirective,
} from "@nowinstore/nowinstore-core-ui/components";
import { SelectionIndicatorComponent } from "./selection-indicator.component";

@Component({
  imports: [
    CommonModule,
    InputTextModule,
    FormsModule,
    NISTemplateModule,
    SelectionIndicatorComponent,
  ],
  standalone: true,
  selector: "nis-option-selector",
  templateUrl: "./option-selector.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OptionSelectorComponent),
      multi: true,
    },
  ],
})
export class OptionSelectorComponent
  implements ControlValueAccessor, AfterContentInit
{
  @ContentChild(NISTemplateDirective) nisTemplate: NISTemplateDirective;
  template: TemplateRef<unknown>;

  @Input() options: any[] = [];
  @Input() disabled: boolean = false;

  value: any;
  onChange: any = () => {};
  onTouched: any = () => {};

  ngAfterContentInit() {
    if (this.nisTemplate) {
      this.template = this.nisTemplate.template;
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectOption(option: any): void {
    this.value = option;
    this.onChange(this.value);
    this.onTouched();
  }
}
